////
/// ============================================================================
/// COMPONENT / Header
/// ============================================================================
///
/// @group components
////

import debounce from "../utils/debounce";

export default () => {

    let Header = function (header) {
        this.header = header;

        this.togglers = this.header.querySelectorAll(".js-header__toggler");
        this.mobileMenuToggler = this.header.querySelector(".js-header__mobile-menu-toggler");
        this.mobileMenu = this._getControls(this.mobileMenuToggler);

        this.panels = [];
        this.togglers.forEach(toggle => {
            let panel = this._getControls(toggle);

            if (panel) {
                this.panels.push(panel);
            }
        });

        this.currentPanel = false;
        this.isMobileMenuOpen = false;

        this.init();
    };

    Header.prototype.init = function () {
        this.setLayout();
        this.bindEvents();
    };

    Header.prototype.setLayout = function () {
        let layout = getComputedStyle(this.header).getPropertyValue("--layout");

        // trim "desktop" -> desktop
        layout = layout.replace(/^"|"$/g, "");

        if (layout === this.layout) {
            return;
        }

        this.layout = layout;
    };

    Header.prototype.bindEvents = function () {
        this.togglers.forEach(toggler => {
            toggler.addEventListener("click", () => {
                this.toggle(toggler);
            });
        });

        this.mobileMenuToggler?.addEventListener("click", () => {
            this.toggleMobileMenu();
        });
    };

    Header.prototype.toggle = function (toggler) {
        let panel = this._getControls(toggler);

        if (this.isMobileMenuOpen && !this.mobileMenu.contains(panel)) {
            this.closeMobileMenu();
        }

        if (this.currentPanel === panel) {
            this.closePanels();
        } else {
            this.closePanels();
            toggler.setAttribute("aria-expanded", "true");
            toggler.closest(".header__item").classList.add("is-expanded");

            panel.classList.add("is-visible");

            this.currentPanel = panel;
        }
    };

    Header.prototype.toggleMobileMenu = function () {
        this.closePanels();

        if (this.isMobileMenuOpen) {
            this.closeMobileMenu();
        } else {
            this.mobileMenuToggler?.setAttribute("aria-expanded", "true");
            this.mobileMenuToggler?.closest(".header__item").classList.add("is-expanded");
            this.mobileMenu?.classList.add("is-visible");
            this.isMobileMenuOpen = true;
        }
    };

    Header.prototype.closePanels = function () {
        this.togglers.forEach(toggler => {
            toggler.removeAttribute("aria-expanded");
            toggler.closest('.header__item').classList.remove("is-expanded");
        });

        this.panels.forEach(panel => {
            panel.classList.remove("is-visible");
        });

        this.currentPanel = false;
    };

    Header.prototype.closeMobileMenu = function () {
        this.mobileMenuToggler?.removeAttribute("aria-expanded");
        this.mobileMenuToggler?.closest(".header__item").classList.remove("is-expanded");
        this.mobileMenu?.classList.remove("is-visible");

        this.isMobileMenuOpen = false;
    };

    Header.prototype._getControls = function (toggler) {
        if (!toggler.hasAttribute("aria-controls")) {
            return null;
        }

        return document.querySelector("#" + toggler.getAttribute("aria-controls"));
    }

    // start
    document.querySelectorAll(".js-header").forEach(container => {
        let header = new Header(container);

        // outer click
        window.addEventListener("click", function (event) {
            if (!event.target.closest(".js-header")) {
                header.closePanels();
                header.closeMobileMenu();
            }
        });

        // window resize
        window.addEventListener("resize", debounce(function () {
            header.setLayout();
        }));
    });
};
